import React, { memo } from 'react'

const UserIcon: React.FC = memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
  >
    <path
      d="M15.2889 14.7198C15.369 14.8403 15.4166 14.9834 15.4264 15.1327C15.4361 15.2819 15.4075 15.4311 15.3439 15.5631C15.281 15.6942 15.1873 15.8041 15.0727 15.881C14.958 15.9579 14.8267 15.999 14.6927 16H1.48553C1.35151 15.999 1.22022 15.9579 1.10558 15.881C0.990942 15.8041 0.897219 15.6942 0.834346 15.5631C0.770721 15.4311 0.742124 15.2819 0.751862 15.1327C0.761601 14.9834 0.809277 14.8403 0.889376 14.7198C1.91484 13.0955 3.36478 11.858 5.04413 11.1739C4.0597 10.4495 3.31196 9.39319 2.91156 8.16139C2.51117 6.92958 2.47939 5.58771 2.82095 4.33434C3.1625 3.08098 3.85923 1.98272 4.80802 1.20211C5.75682 0.421495 6.90727 0 8.08912 0C9.27097 0 10.4214 0.421495 11.3702 1.20211C12.319 1.98272 13.0157 3.08098 13.3573 4.33434C13.6988 5.58771 13.6671 6.92958 13.2667 8.16139C12.8663 9.39319 12.1185 10.4495 11.1341 11.1739C12.8135 11.858 14.2634 13.0955 15.2889 14.7198Z"
      fill="currentColor"
    />
  </svg>
))

export { UserIcon }
